// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listst-panels:has(.active) {
  margin-top: 10px;

  .button {
    float: right;
  }
}

.listst-panels hr {
  margin: 15px 0;
}

.listst-panels .listst-panels-buttons {
  display: flex;
}

.listst-panels .panel {
  background-color: var(--simplepopup-background-color);
  width: 290px;
  display: none;
  padding: 10px;
  color: var(--simplepopup-color);
  position:absolute;
  top: 6%;
  z-index: 9;
  text-align: left;
}

.listst-panels .panel.active {
  display: block;
  
  
}

.listst-panels .panel .close {
  position: absolute;
  right: 10px;
}

.listst-panels .panel .title {
  text-align: center;
  margin: 0;
  margin-bottom: 5px;
  font-size: 1.5em;
}

.listst-panels .panel .label {
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 0;
}

.listst-panels .panel .color .buttons {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

.listst-panels .panel .color .buttons .item {
  margin-right: 5px;
  cursor: pointer;
}

.listst-panels .panel .radiobuttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.listst-panels .panel .radiobuttons .radiobutton {
  margin-right: 15px;
}

.listst-panels .panel .radiobuttons .radiobutton input {
  vertical-align: text-top;
}

.listst-panels .panel .radiobuttons .radiobutton label {
  font-size: 13px;
}

.listst-panels .panel .range {
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
}

.listst-panels .panel .range .group {
  display: flex;
  flex-direction: column;
}

.listst-panels .panel .range .group label {
  font-size: 14px;
}

.listst-panels .panel .range .group input {
  width: 80px;
}

.listst-panels .panel .range .text {
  font-size: 14px;
  margin: 0 20px;
  align-content: end;
}

.listst-panels .panel .reverse-search {
  margin-top: 5px;
}

.listst-panels .panel .reverse-search input {
  vertical-align: bottom;
}

.listst-panels .panel .duplication .control input,
.listst-panels .panel .cut-paste .control input {
  width: 70px;
  margin: 0 10px;
}

.listst-panels .panel .control .flex {
  display: flex;
}

.listst-panels .panel fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

.listst-panels .panel fieldset legend {
  line-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/subtitles/list-st/components/filter/filter.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;;EAEhB;IACE,YAAY;EACd;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,iBAAiB;EACjB,OAAO;EACP,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;;;AAGhB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".listst-panels:has(.active) {\n  margin-top: 10px;\n\n  .button {\n    float: right;\n  }\n}\n\n.listst-panels hr {\n  margin: 15px 0;\n}\n\n.listst-panels .listst-panels-buttons {\n  display: flex;\n}\n\n.listst-panels .panel {\n  background-color: var(--simplepopup-background-color);\n  width: 290px;\n  display: none;\n  padding: 10px;\n  color: var(--simplepopup-color);\n  position:absolute;\n  top: 6%;\n  z-index: 9;\n  text-align: left;\n}\n\n.listst-panels .panel.active {\n  display: block;\n  \n  \n}\n\n.listst-panels .panel .close {\n  position: absolute;\n  right: 10px;\n}\n\n.listst-panels .panel .title {\n  text-align: center;\n  margin: 0;\n  margin-bottom: 5px;\n  font-size: 1.5em;\n}\n\n.listst-panels .panel .label {\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 0;\n}\n\n.listst-panels .panel .color .buttons {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 5px;\n}\n\n.listst-panels .panel .color .buttons .item {\n  margin-right: 5px;\n  cursor: pointer;\n}\n\n.listst-panels .panel .radiobuttons {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.listst-panels .panel .radiobuttons .radiobutton {\n  margin-right: 15px;\n}\n\n.listst-panels .panel .radiobuttons .radiobutton input {\n  vertical-align: text-top;\n}\n\n.listst-panels .panel .radiobuttons .radiobutton label {\n  font-size: 13px;\n}\n\n.listst-panels .panel .range {\n  display: flex;\n  flex-direction: row;\n  text-align: center;\n  justify-content: center;\n}\n\n.listst-panels .panel .range .group {\n  display: flex;\n  flex-direction: column;\n}\n\n.listst-panels .panel .range .group label {\n  font-size: 14px;\n}\n\n.listst-panels .panel .range .group input {\n  width: 80px;\n}\n\n.listst-panels .panel .range .text {\n  font-size: 14px;\n  margin: 0 20px;\n  align-content: end;\n}\n\n.listst-panels .panel .reverse-search {\n  margin-top: 5px;\n}\n\n.listst-panels .panel .reverse-search input {\n  vertical-align: bottom;\n}\n\n.listst-panels .panel .duplication .control input,\n.listst-panels .panel .cut-paste .control input {\n  width: 70px;\n  margin: 0 10px;\n}\n\n.listst-panels .panel .control .flex {\n  display: flex;\n}\n\n.listst-panels .panel fieldset {\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n\n.listst-panels .panel fieldset legend {\n  line-height: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
